export default "__VITE_ASSET__Bbncjrtr__"